import type { ParentVerification } from '../types/community'

/** The server's status is authoritative; missing or expired evidence must never unlock the UI. */
export function hasCurrentVerification(value?: ParentVerification | null): boolean {
  return value?.status === 'Verified' && value.provider === 'stripe' && !!value.verifiedAt
    && !!value.validUntil && Date.parse(value.validUntil) > Date.now()
}

/** Local Vite testing only, and only when the server explicitly authorizes its own test bypass. */
export function canUseDevelopmentVerificationSkip(value?: ParentVerification | null): boolean {
  return import.meta.env.DEV === true && value?.testMode === true
    && value.requiresVerification === false && value.onboardingComplete === true
    && !hasCurrentVerification(value)
}

export function canEnterCommunity(value?: ParentVerification | null): boolean {
  return canUseDevelopmentVerificationSkip(value)
    || (!!value?.onboardingComplete && value.launchReady && hasCurrentVerification(value))
}
